export const enum LiftIgniterCheckerState {
    STATE_WAITING_FOR_STUB = 0,
    STATE_WAITING_FOR_LIB_LOAD = 1,
    STATE_LIB_LOADED = 2,
}

export function logWarn(_s: string) {} // eslint-disable-line
export function logInfo(_s: string) {} // eslint-disable-line

/**
 * Since the LiftIgniter $p stub is lower in the page than this script,
 * we have to wait for it
 */
export class LiftIgniterChecker {
    private state: LiftIgniterCheckerState;
    private onReadyStateChange: (e: Event) => void;

    constructor() {
        this.state = LiftIgniterCheckerState.STATE_WAITING_FOR_STUB;
        this.onReadyStateChange = (e) => this.checkForStub(`${e.type} ${document.readyState}`);
        document.addEventListener('readystatechange', this.onReadyStateChange);
    }

    public isReady() {
        this.checkForStub('isReady()');
        return this.state === LiftIgniterCheckerState.STATE_LIB_LOADED;
    }

    public send(batchName: string, batchSummary: any) {
        window.$p?.('send', batchName, batchSummary);
    }

    private checkForStub(reason: string) {
        if (this.state !== LiftIgniterCheckerState.STATE_WAITING_FOR_STUB) {
            return;
        } else if (!window.$p) {
            return;
        }

        logInfo(`checkforstub triggered by ${reason}: $p found`);
        document.removeEventListener('readystatechange', this.onReadyStateChange);
        this.state = LiftIgniterCheckerState.STATE_WAITING_FOR_LIB_LOAD;
        window.$p('onload', () => this.onLiftIgniterLoad());
    }

    private onLiftIgniterLoad() {
        this.state = LiftIgniterCheckerState.STATE_LIB_LOADED;
        void window.liftIgniterLoadPromiseResolved?.();
    }
}
